





















import { Component, Watch, Vue } from "vue-property-decorator";
import { mapState } from "vuex";
import { BPagination } from "bootstrap-vue";
import Header from "@/components/Header.vue";
import EntityTabs from "@/components/EntityTabs.vue";
import Pager from "@/components/schedule/Pager.vue";
import CalendarView from "@/components/schedule/Calendar.vue";
import ListView from "@/components/schedule/List.vue";
import ApptEditor from "@/components/schedule/Appt2.vue";
import ApptLog from "@/components/schedule/Log.vue";
import { ScheduleView } from "@/store/modules/enums";
import StatusCount from "@/components/schedule/StatusCount.vue";
import ReminderCount from "@/components/schedule/ReminderCount.vue";
//
import { ScheduleLogEntry,Form,FormQuestion,Patient } from "@/store/modules/types";
import { ScheduleLogType } from "@/store/modules/enums";
import { getHubConnection } from "@/services/signalr";
//
import FormViewerPdf from "@/components/FormViewerPdf.vue";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
//
//import html2pdf from "html2pdf.js";
//

//var hub = getHubConnection("whatsapp");

@Component({
  components: {
    BPagination,
    Header,
    EntityTabs,
    Pager,
    CalendarView,
    ListView,
    ApptEditor,
    ApptLog,
    StatusCount,
    ReminderCount,
    FormViewerPdf
  },
  computed: {
    ...mapState("schedule", ["view", "list", "reminderCount", "statusCount", "apptComments"]),
  },
})
export default class Schedule extends Vue {
  view!: ScheduleView;
  list!: any;
  reminderCount!: any;
  statusCount!: any;
  selected: any | null = null;
  apptComments!: any;
  //
   pdfForm = {
    form: {} as Form,
    questions: Array<FormQuestion>(),
    patient:{} as Patient
  };
  //
  hub = getHubConnection("whatsapp");
  //hub = hub;
  connected = false;
  groupName = this.$store.state.schedule.list.filter.entityId.toString();
  oldGroupName = "";
  //
  @Watch("list.filter", { deep: true })
  onFilterChanged() {
    this.getAppts();
    if (this.groupName != this.list.filter.entityId) {
      this.oldGroupName = this.groupName;
      this.groupName = this.list.filter.entityId.toString();
      // console.log("groupName" + this.groupName);
      //this.addToGroup();
      this.restartHub();
    }
    /* this.getApptStatusCount(); */
  }

  /* @Watch("store.state.auth.entityId", { deep: true })
   onFilterChanged() {
    console.log("change");
   }*/

  async getAppts() {
    this.$store.commit("main/SET_LOADING", true);
    try {
      await this.$store.dispatch("schedule/getApptList");
      this.getApptStatusCount();
      this.getApptReminderCount();
      this.getApptComments();
    } catch (error) {
      console.log(error);
    } finally {
      this.$store.commit("main/SET_LOADING", false);
    }
  }
  async getApptStatusCount() {
    this.$store.commit("main/SET_LOADING", true);
    try {
      await this.$store.dispatch("schedule/getApptStatusCount");
    } catch (error) {
      console.log(error);
    } finally {
      this.$store.commit("main/SET_LOADING", false);
    }
  }
  async getApptReminderCount() {
    this.$store.commit("main/SET_LOADING", true);
    try {
      await this.$store.dispatch("schedule/getApptReminderCount");
    } catch (error) {
      console.log(error);
    } finally {
      this.$store.commit("main/SET_LOADING", false);
    }
  }
  async getApptComments() {
    //this.$store.commit("main/SET_LOADING", true);
    try {
      await this.$store.dispatch("schedule/getApptComments", {});
    } catch (error) {
      console.log(error);
    } finally {
      //this.$store.commit("main/SET_LOADING", false);
    }
  }
  async markMessageRead(id) {
    // this.$store.commit("main/SET_LOADING", true);
    try {
      await this.$store.dispatch("schedule/markLogRead", id);
      this.getApptComments();
    } catch (error) {
      console.log(error);
    } finally {
      //this.$store.commit("main/SET_LOADING", false);
    }
  }

  async saveMessage(message) {
    if (!message.officeMessage) return;
    const entry: ScheduleLogEntry = {
      apptId: message.scheduleId,
      typeId: ScheduleLogType.OFFICE_TO_PATIENT_COMMENT,
      comment: message.officeMessage,
    };
    this.$store.commit("main/SET_LOADING", true);
    try {
      await this.$store.dispatch("schedule/saveLog", entry);
    } catch (error) {
      console.log(error);
    } finally {
      this.$store.commit("main/SET_LOADING", false);
    }
  }

  //signalr
  async setHub() {
    try {
      this.hub.onreconnected(() => {
        this.addToGroup();
      });
      this.hub.onclose(() => {
        this.connected = false;
      });
      this.hub.onreconnecting(() => {
        this.connected = false;
      });
      this.hub.on("Reminder", (event) => {
        event = JSON.parse(event);
        if (event.type == "RMD") {
          this.updateAppt(event);
          //this.getApptComments();
        }
      });
      await this.hub.start();
      await this.addToGroup();
    } catch (error) {
      console.log(error);
    }
  }



  async restartHub() {
    await this.hub.invoke(
      "RemoveFromGroup",
      this.oldGroupName
      //this.$store.state.auth.entityId
    );
    await this.addToGroup();
  }

  async addToGroup() {
    try {
      //console.log("addToGroup: " + this.groupName);
      this.connected = await this.hub.invoke(
        "JoinGroup",
        this.groupName
        //this.$store.state.auth.entityId
      );
    } catch (error) {
      console.log(error);
      this.connected = false;
    }
  }

  async removeFromGroup() {
    try {
      this.connected = await this.hub.invoke(
        "RemoveFromGroup",
        this.oldGroupName
      );
    } catch (error) {
      console.log(error);
      this.connected = false;
    }
  }

  updateAppt(event: any) {
    switch (event.status) {
      case "READ":
        this.list.pageRows.find(function (appt) {
          if (event.id == appt.id)
            appt.viewedByPatient = true;

        })
        break;
      case "DELIVERED":
        this.list.pageRows.find(function (appt) {
          if (event.id == appt.id)
            appt.reminderDelivered = true;

        })
        break;
      case "PCO":
        this.list.pageRows.find(function (appt) {
          if (event.id == appt.id) {
            appt.hasComments = true;
          }
        })

        if (this.apptComments.total < 15) {
          this.apptComments.list.splice(0, 0, event.message);
          this.apptComments.total = this.apptComments.total + 1
        }

        break;
      default:

        break;
    }

  }

  //
  editAppt(appt: any) {
    this.selected = appt;
    this.$modal.show("appt-editor");
  }
  showLog(appt: any) {
    this.selected = appt;
    this.$modal.show("appt-log");
  }
  get ScheduleView() {
    return ScheduleView;
  }

  /*  showPDF(){
    const questions: FormQuestion[] = [
  {
    id: 1,
    key: "H9AW20H6",
    position: 1,
    section: "",
    title:
      "Persona y/o representante autorizado que recibe la orientación sobre el programa y provee información para completar el estimado de salud.",
    text: "",
    component: "SingleChoiceAnswer",
    options: {
      config: { customChoice: false },
      caseField: "",
      gapField: "",
      apptField: "",
      list: [
        {
          text: "Asegurado",
          value: "Asegurado",
          checked: false,
          jumpToKey: "",
          updateGap: null,
          updateAppt: null,
        },
        {
          text: "Cuidador/Familiar",
          value: "Cuidador/Familiar",
          checked: false,
          jumpToKey: "",
          updateGap: null,
          updateAppt: null,
        },
        {
          text: "Representante Autorizado/Legal/Tutor",
          value: "Representante Autorizado/Legal/Tutor",
          checked: false,
          jumpToKey: "",
          updateGap: null,
          updateAppt: null,
        },
        {
          text: "Administrador de Hogar/Egida/Casa de Salud",
          value: "Administrador de Hogar/Egida/Casa de Salud",
          checked: false,
          jumpToKey: "",
          updateGap: null,
          updateAppt: null,
        },
        {
          text: "Profesional de la Salud: Enfermera, Médico",
          value: "Profesional de la Salud: Enfermera, Médico",
          checked: false,
          jumpToKey: "",
          updateGap: null,
          updateAppt: null,
        },
      ],
    },
    isOptional: false,
    isExpired: true,
    answer: {
      value: "",
      created: "",
      createdBy: "",
      updated: "",
      updatedBy: "",
      jumpToKey: "",
      updateGap: null,
    },
  }
];


const form={
    "id": 1,
    "name": "Test Form",
    "hasAnswers": false
};

this.pdfForm={form,questions};
   } */



  /* async exportPDF(data) {
     const html2pdf = (await import("html2pdf.js/dist/html2pdf.min.js")).default;
  this.$store.commit("main/SET_LOADING", true);
  this.pdfForm = data;
  await this.$nextTick();

  const element = document.getElementById("pdf-form-viewer");
  if (!element) return;

  const opt: any = {
    margin: [10, 10, 10, 10],
    filename: `${this.pdfForm.form.name || "form"}.pdf`,
    image: { type: "jpeg", quality: 0.98 },
    html2canvas: {
      scale: 2,
      useCORS: true,
      scrollY: 0,
    },
    jsPDF: { unit: "mm", format: "a4", orientation: "portrait" },
    pagebreak: { mode: ["avoid-all", "css", "legacy"] },
  };

  await html2pdf().set(opt).from(element).save();
  this.$store.commit("main/SET_LOADING", false);
}
 */

 async exportPDFNoFunciona(data) {
  this.$store.commit("main/SET_LOADING", true);
  this.pdfForm = data;
  await this.$nextTick();

  const element = document.getElementById("pdf-form-viewer");
  if (!element) return;

  const canvas = await html2canvas(element, {
    scale: 2,
    useCORS: true,
    scrollY: 0,
  });

  const imgData = canvas.toDataURL("image/png");
  const pdf = new jsPDF("p", "mm", "a4");
  const pdfWidth = pdf.internal.pageSize.getWidth();
  const pdfHeight = pdf.internal.pageSize.getHeight();

  const imgWidth = pdfWidth;
  const imgHeight = (canvas.height * pdfWidth) / canvas.width;

  let heightLeft = imgHeight;
  let position = 0;

  pdf.addImage(imgData, "PNG", 0, position, imgWidth, imgHeight);
  heightLeft -= pdfHeight;

  while (heightLeft > 0) {
    position = heightLeft - imgHeight;
    pdf.addPage();
    pdf.addImage(imgData, "PNG", 0, position, imgWidth, imgHeight);
    heightLeft -= pdfHeight;
  }

  pdf.save(`${this.pdfForm.form.name || "form"}.pdf`);
  this.$store.commit("main/SET_LOADING", false);
}
async exportPDFT(data) {
this.pdfForm = data;
}
async exportPDF(data) {
  try {
    this.$store.commit("main/SET_LOADING", true);
    this.pdfForm = data;

    await this.$nextTick();

    const element = document.getElementById("pdf-form-viewer");
    if (!element) return;

    // Mostrar el contenido fuera de la vista
    element.style.display = "block";
    element.style.position = "absolute";
    element.style.top = "-9999px";

    // Esperar carga del logo o imágenes
    await new Promise((resolve) => setTimeout(resolve, 500));

    const pdf = new jsPDF("p", "mm", "a4");
    const pageWidth = pdf.internal.pageSize.getWidth();
    const pageHeight = pdf.internal.pageSize.getHeight();
    const margin = 8;
    let currentY = margin;

    // === HEADER (solo una vez) ===
    const header = element.querySelector(".pdf-header") as HTMLElement;
    let headerHeight = 0;

    if (header) {
      const headerCanvas = await html2canvas(header, { scale: 2, useCORS: true });
      const imgData = headerCanvas.toDataURL("image/png");
      const imgWidth = pageWidth - margin * 2;
      headerHeight = (headerCanvas.height * imgWidth) / headerCanvas.width;
      pdf.addImage(imgData, "PNG", margin, currentY, imgWidth, headerHeight);
      currentY += headerHeight + 6;
    }

    // === PATIENT INFO ===
const patientInfo = element.querySelector(".pdf-patient-info") as HTMLElement;
//console.log(patientInfo);
if (patientInfo) {
  const patientCanvas = await html2canvas(patientInfo, { scale: 2, useCORS: true });
  const imgData = patientCanvas.toDataURL("image/png");
  const imgWidth = pageWidth - margin * 2;
  const imgHeight = (patientCanvas.height * imgWidth) / patientCanvas.width;

  if (currentY + imgHeight + 15 > pageHeight - margin) {
    pdf.addPage();
    currentY = margin;
  }

  pdf.addImage(imgData, "PNG", margin, currentY, imgWidth, imgHeight);
  currentY += imgHeight + 6;
}

    // === BODY (preguntas, sin cortar bloques) ===
    const blocks = Array.from(element.querySelectorAll(".pdf-question")) as HTMLElement[];
    for (let i = 0; i < blocks.length; i++) {
      const block = blocks[i];
      const canvas = await html2canvas(block, {
        scale: 2,
        useCORS: true,
        scrollY: -window.scrollY,
      });

      const imgData = canvas.toDataURL("image/png");
      const imgWidth = pageWidth - margin * 2;
      const imgHeight = (canvas.height * imgWidth) / canvas.width;

      // Si no cabe, crear nueva página sin header
      if (currentY + imgHeight + 15 > pageHeight - margin) {
        pdf.addPage();
        currentY = margin; // sin header
      }

      pdf.addImage(imgData, "PNG", margin, currentY, imgWidth, imgHeight);
      currentY += imgHeight + 4;
    }

    // === FOOTER (solo en la última página) ===
    const footerText = "Powered by WaitingMed";
    pdf.setFontSize(10);
    pdf.setTextColor(120, 120, 120);
    pdf.text(footerText, pageWidth / 2, pageHeight - 6, { align: "center" });

    // === Guardar PDF ===
    const now = new Date();
    const formattedDate = now.toISOString().split("T")[0];
    pdf.save(`${this.pdfForm.form.name || "form"}_${formattedDate}.pdf`);

    element.style.display = "none";
  } catch (error) {
    console.error("Error generating PDF:", error);
  } finally {
    this.$store.commit("main/SET_LOADING", false);
  }
}


async exportPDFRepiteLosHeader(data) {
  try {
    this.$store.commit("main/SET_LOADING", true);
    this.pdfForm = data;
    await this.$nextTick();

    const element = document.getElementById("pdf-form-viewer");
    if (!element) return;

    // Asegurar visibilidad fuera de pantalla
    element.style.display = "block";
    element.style.position = "absolute";
    element.style.top = "-9999px";

    await new Promise((resolve) => setTimeout(resolve, 500));

    const pdf = new jsPDF("p", "mm", "a4");
    const pageWidth = pdf.internal.pageSize.getWidth();
    const pageHeight = pdf.internal.pageSize.getHeight();
    const margin = 8;
    let currentY = margin;

    // === HEADER ===
    const header = element.querySelector(".pdf-header") as HTMLElement;
    let headerHeight = 0;
    if (header) {
      const headerCanvas = await html2canvas(header, { scale: 2, useCORS: true });
      const imgData = headerCanvas.toDataURL("image/png");
      const imgWidth = pageWidth - margin * 2;
      headerHeight = (headerCanvas.height * imgWidth) / headerCanvas.width;
      pdf.addImage(imgData, "PNG", margin, currentY, imgWidth, headerHeight);
      currentY += headerHeight + 6;
    }

    // === BODY (questions) ===
    const blocks = Array.from(element.querySelectorAll(".pdf-question")) as HTMLElement[];
    for (let i = 0; i < blocks.length; i++) {
      const block = blocks[i];

      const canvas = await html2canvas(block, {
        scale: 2,
        useCORS: true,
        scrollY: -window.scrollY,
      });

      const imgData = canvas.toDataURL("image/png");
      const imgWidth = pageWidth - margin * 2;
      const imgHeight = (canvas.height * imgWidth) / canvas.width;

      // Si el bloque no cabe en la página actual → nueva página con header
      if (currentY + imgHeight + 15 > pageHeight - margin) {
        pdf.addPage();
        currentY = margin;

        // Repetir el header en cada página
        if (header) {
          pdf.addImage(
            (await html2canvas(header, { scale: 2, useCORS: true })).toDataURL("image/png"),
            "PNG",
            margin,
            currentY,
            imgWidth,
            headerHeight
          );
          currentY += headerHeight + 6;
        }
      }

      pdf.addImage(imgData, "PNG", margin, currentY, imgWidth, imgHeight);
      currentY += imgHeight + 4;
    }

    // === FOOTER (solo en la última página) ===
    const footerText = "Powered by WaitingMed";
    pdf.setFontSize(10);
    pdf.setTextColor(120, 120, 120);
    pdf.text(
      footerText,
      pageWidth / 2,
      pageHeight - 6,
      { align: "center" }
    );

    // === Guardar ===
    const now = new Date();
    const formattedDate = now.toISOString().split("T")[0];
    pdf.save(`${this.pdfForm.form.name || "form"}_${formattedDate}.pdf`);

    element.style.display = "none";
  } catch (error) {
    console.error("Error generating PDF:", error);
  } finally {
    this.$store.commit("main/SET_LOADING", false);
  }
}


async exportPDFFuncionaSinHeader(data) {
  try {
    this.$store.commit("main/SET_LOADING", true);
    this.pdfForm = data;
    await this.$nextTick();

    const element = document.getElementById("pdf-form-viewer");
    if (!element) return;

    // Mostrar fuera de pantalla
    element.style.display = "block";
    element.style.position = "absolute";
    element.style.top = "-9999px";

    await new Promise((resolve) => setTimeout(resolve, 500));

    const pdf = new jsPDF("p", "mm", "a4");
    const pageWidth = pdf.internal.pageSize.getWidth();
    const pageHeight = pdf.internal.pageSize.getHeight();
    const margin = 5;
    let currentY = margin;

    // 🔹 Selecciona cada bloque de pregunta
    const blocks = Array.from(
      element.querySelectorAll(".pdf-question")
    ) as HTMLElement[];

    for (let i = 0; i < blocks.length; i++) {
      const block = blocks[i];

      // Renderiza cada bloque por separado
      const canvas = await html2canvas(block, {
        scale: 2,
        useCORS: true,
        scrollY: -window.scrollY,
      });

      const imgData = canvas.toDataURL("image/png");
      const imgWidth = pageWidth - margin * 2;
      const imgHeight = (canvas.height * imgWidth) / canvas.width;

      // Si el bloque no cabe en la página actual → nueva página
      if (currentY + imgHeight > pageHeight - margin) {
        pdf.addPage();
        currentY = margin;
      }

      // Agregar la imagen
      pdf.addImage(imgData, "PNG", margin, currentY, imgWidth, imgHeight);
      currentY += imgHeight + 4; // espacio entre bloques
    }

    // 🔹 Guardar PDF
    const now = new Date();
    const formattedDate = now.toISOString().split("T")[0];
    pdf.save(`${this.pdfForm.form.name || "form"}_${formattedDate}.pdf`);

    element.style.display = "none";
  } catch (error) {
    console.error("Error generating PDF:", error);
  } finally {
    this.$store.commit("main/SET_LOADING", false);
  }
}


  async exportPDFSiFunciona(data) {
  try {
    this.$store.commit("main/SET_LOADING", true);

    // 1️⃣ Asignar el form al PDF
    this.pdfForm = data;
    await this.$nextTick();

    // 2️⃣ Obtener el elemento
    const element = document.getElementById("pdf-form-viewer");
    if (!element) return;

    // 3️⃣ Asegurarse de que sea visible
    /*
    element.style.display = "block";
    element.style.position = "static"; // No lo muevas fuera del viewport
*/

element.style.display = "block";
      element.style.position = "absolute";
      element.style.top = "-9999px";

    // 4️⃣ Esperar un poco a que se carguen imágenes remotas (logo)
    await new Promise((resolve) => setTimeout(resolve, 500));

    // 5️⃣ Capturar todo el contenido, aunque sea más alto que la pantalla
    const canvas = await html2canvas(element, {
      scale: 2,
      useCORS: true,
      scrollY: -window.scrollY,
      windowWidth: element.scrollWidth,
      windowHeight: element.scrollHeight,
    });

    const imgData = canvas.toDataURL("image/png");

    // 6️⃣ Crear el PDF con ajuste automático de páginas si es largo
    const pdf = new jsPDF("p", "mm", "a4");
    const pageWidth = pdf.internal.pageSize.getWidth();
    const pageHeight = pdf.internal.pageSize.getHeight();
    const imgWidth = pageWidth;
    const imgHeight = (canvas.height * pageWidth) / canvas.width;

    let heightLeft = imgHeight;
    let position = 0;

    // Primera página
    pdf.addImage(imgData, "PNG", 0, position, imgWidth, imgHeight);
    heightLeft -= pageHeight;

    // Si hay contenido adicional, agregar páginas
    while (heightLeft > 0) {
      position = heightLeft - imgHeight;
      pdf.addPage();
      pdf.addImage(imgData, "PNG", 0, position, imgWidth, imgHeight);
      heightLeft -= pageHeight;
    }

    // 7️⃣ Guardar
    pdf.save(`${this.pdfForm.form.name || "form"}.pdf`);

    // 8️⃣ Restaurar estado visual
    element.style.display = "none";
  } catch (error) {
    console.error("Error generating PDF:", error);
  } finally {
    this.$store.commit("main/SET_LOADING", false);
  }
}

  async exportPDFBK1(data) {
this.$store.commit("main/SET_LOADING", true);
      // 1️⃣ Asignar el form recibido al PDF oculto

      this.pdfForm=data;

      // 2️⃣ Esperar a que Vue pinte el nuevo contenido
      await this.$nextTick();

      // 3️⃣ Mostrar temporalmente y generar el PDF
      const element = document.getElementById("pdf-form-viewer");
      if (!element) return;

      element.style.display = "block";
      element.style.position = "absolute";
      element.style.top = "-9999px";

      //await new Promise(resolve => setTimeout(resolve, 300));

      const canvas = await html2canvas(element, {
        scale: 2,
        useCORS: true,
      });

      const imgData = canvas.toDataURL("image/png");
      const pdf = new jsPDF("p", "mm", "a4");
      const pdfWidth = pdf.internal.pageSize.getWidth();
      const pdfHeight = (canvas.height * pdfWidth) / canvas.width;
      pdf.addImage(imgData, "PNG", 0, 0, pdfWidth, pdfHeight);
      pdf.save(`${this.pdfForm.form.name || "form"}.pdf`);

      element.style.display = "none";
this.$store.commit("main/SET_LOADING", false);
      
    }
  

  mounted() {
    this.getAppts();
    this.getApptStatusCount();
    this.getApptComments();
    this.setHub();
    this.$root.$on('export-pdf', this.exportPDF);
  }
}
